// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-card__title[data-v-5f805acf]{margin:0}.content-card__wrapper[data-v-5f805acf]{padding:0 30px 30px;margin-top:-40px}@media only screen and (max-width: 768px){.content-card__wrapper[data-v-5f805acf]{padding:0 20px 20px}}.content-card__plain[data-v-5f805acf]{padding:30px}@media only screen and (max-width: 768px){.content-card__plain[data-v-5f805acf]{padding:20px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
